import React, {useState} from "react";
import "./style.css";

export const FloatingBanner = ({
  message,
  header,
  acceptText,
  denyText,
  onAccept,
  onAcceptCustom,
  onDeny,
  manage_cookies,
  necessary_cookies,
  analysis_cookies,
  cookies_config,
  allow_selection
}) => {

  const [showCustom, setShowCustom] = useState(false);

  return (
    <div className={`w-100 d-flex position-fixed my-0 mx-0 top-0 left-0 justify-content-center align-items-center vh-100 overflow-auto`} style={{ zIndex: "2000", background: "rgb(12,10,9, 0.7)" }}>
      <div className="mx-auto m-auto py-3 px-3" style={{maxWidth: "600px"}}>
        <div className="p-3 rounded-lg bg-dark shadow">
          <div className="d-flex gap-1 align-items-center justify-content-between flex-wrap">
            <div className="d-flex flex-sm-fill align-items-center">
              <div className="d-flex flex-column">
                <div style={{ solor: "#cbcbcb"}} className="ml-3 mb-3 font-weight-bold text-center h4">{header}</div>
                <div className="ml-3 font-weight-bold text-white">
                  <span className="d-md-none">{message}</span>
                  <span className="d-none d-md-inline">{message}</span>
                </div>
              </div>
            </div>

            {
            
            showCustom &&

              <div className="ml-2 text-dark bg-white my-4 p-3 w-100 rounded">
                <h5 className="h6 mb-3 text-secondary">{manage_cookies}</h5>

                <div className="d-flex p-2 border mb-2 align-items-center">
                  <div className="flex-none w-5">+</div>
                  <div className="flex-initial w-75 flex-grow">{necessary_cookies}</div>
                  <div className="text-blue-300 flex-fill">
                  <div className="text-blue-300 flex-fill">
                    <input type="checkbox" disabled checked />
                  </div>
                  </div>
                </div>

                <div className="d-flex p-2 border mb-2 align-items-center">
                  <div className="flex-none w-5">+</div>
                  <div className="flex-initial w-75 flex-grow">{analysis_cookies}</div>
                    <div className="text-primary flex-fill">
                    <input type="checkbox" id="checkbox_cookies_analytics_storage" />
                  </div>
                </div>

                <button
                  className="shadow mx-auto d-flex align-items-center justify-content-center px-4 py-2 border border-transparent text-sm font-weight-medium rounded text-dark bg-white hover:text-dark focus-outline-none focus-shadow-outline transition-ease-in-out duration-150"
                  onClick={onAcceptCustom}
                >
                  {allow_selection}
                </button>
              </div>

            }

            <div className="d-flex justify-content-around gap-2 mt-4 w-100 mx-auto ml-2">

              <div className="d-sm-flex ml-sm-2">
                <button
                  style={{color: "#cbcbcb"}}
                  className="text-slate-400 d-flex align-items-center justify-content-center px-4 py-2 text-sm font-weight-medium rounded-md bg-dark border-black border rounded border-2 hover:text-black-500 focus-outline-none focus-shadow-outline transition ease-in-out duration-150"
                  onClick={onDeny}
                >
                  {denyText}
                </button>
              </div>

              <div className="d-sm-flex flex-shrink-0 mt-sm-0 w-auto">
                <div className="rounded-md shadow-sm">
                    <button
                      className="d-flex align-items-center justify-content-center px-5 py-2 border border-0 text-sm font-weight-medium rounded text-black-600 bg-white hover:text-black-500 focus-outline-none focus-shadow-outline transition-ease-in-out duration-150"
                      onClick={onAccept}
                    >
                      {acceptText}
                    </button>
                </div>
              </div>

            </div>

            <div style={{textDecoration: "underline"}} className="text-white mx-auto cursor_pointer mt-2" onClick={() => setShowCustom(!showCustom)}>{cookies_config}</div>
          </div>
        </div>
      </div>
    </div>
  )

};
